import { render } from "./index.vue?vue&type=template&id=f3c1a49a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "../styles/ModalEditBusinessInformation.scss?vue&type=style&index=0&id=f3c1a49a&lang=scss&scoped=true"
import "@/assets/css/newdesign.scss?vue&type=style&index=1&id=f3c1a49a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c1a49a"]])

export default __exports__